import React from 'react';
import type { CSSProperties, ReactNode } from 'react';

import { styles } from '@actual-app/components/styles';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

type StatTileProps = {
  label: ReactNode;
  children: ReactNode;
  style?: CSSProperties;
};

export function StatTile({ label, children, style }: StatTileProps) {
  return (
    <View
      style={{
        minWidth: 0,
        padding: '12px 10px',
        borderRadius: 'var(--radius-lg)',
        backgroundColor: theme.cardBackground,
        boxShadow: styles.cardShadow,
        gap: 6,
        ...style,
      }}
    >
      <View
        style={{
          ...styles.smallText,
          color: theme.pageTextSubdued,
          ...styles.ellipsisText,
        }}
      >
        {label}
      </View>
      <View style={{ fontSize: 18, fontWeight: 600, ...styles.tnum }}>
        {children}
      </View>
    </View>
  );
}
